import { AJAX_CALL_ERROR } from '../actionTypes';

export default function ajaxCallError(error) {
    return { 
        type: AJAX_CALL_ERROR,
        payload: error || {}
    }
}